import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import confirmTypes from 'helpers/enums/confirmTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { localize } from 'helpers/translator'

import generalActions from 'redux/actions/generalActions'
import oeqActions from 'redux/actions/oeqActions'
import Confirm from 'views/confirm/confirm'

const CONFIRM_TYPE = confirmTypes.OEQ_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR

const OeqUploadReferenceMediaErrorConfirm = props => (
	<Confirm
		btOne={localize('global_no')}
		btTwo={localize('global_yes')}
		alertMessage={props.message}
		actionButtonType={0}
		actionOne={() => props.actions.closeConfirm(CONFIRM_TYPE)}
		actionTwo={
			() => {
				props.actions.requireUploadConfirmation()
				props.actions.closeConfirm(CONFIRM_TYPE)
			}
		}
		closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: generalActions.closeConfirm,
		requireUploadConfirmation: oeqActions.requireUploadConfirmation,
	}, dispatch)
}

OeqUploadReferenceMediaErrorConfirm.defaultProps = {
	message: '',
	actions: {},
}

OeqUploadReferenceMediaErrorConfirm.propTypes = {
	message: PropTypes.string,
	actions: PropTypes.object,
}

export default connect(null, mapDispatchToProps)(OeqUploadReferenceMediaErrorConfirm)
